import { z } from 'zod';
import { makeEvent } from './EventBase';
import { Agreement } from '@/api';

export const AgreementUpdated = makeEvent(
    'AgreementUpdated',
    z.object({
        data: Agreement,
    }),
);

export type AgreementUpdated = (typeof AgreementUpdated)['schema']['_output'];
